import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAdminAuth } from '../context/AdminAuthContext';
import { PageSkeleton } from '../../components/loading/skeletons';
import { useAdminPermissions } from '../hooks/useAdminPermissions';
import { ADMIN_PERMISSIONS } from '../constants/permissions';
import { ADMIN_PATHS, adminPath } from '../constants/adminPaths';

const AdminPermissionRoute = ({ children, requiredPermissions = [] }) => {
  const { admin, loading } = useAdminAuth();
  const { hasPermission } = useAdminPermissions();

  if (loading) {
    return <PageSkeleton fill label="Loading admin" />;
  }

  if (!admin) {
    return <Navigate to={adminPath(ADMIN_PATHS.LOGIN)} replace />;
  }

  if (requiredPermissions.length > 0) {
    const allowed = requiredPermissions.every(p => hasPermission(p));
    if (!allowed) {
      // Fallback to first accessible route for this admin
      if (hasPermission(ADMIN_PERMISSIONS.SUPPORT.VIEW)) {
        return <Navigate to={adminPath(ADMIN_PATHS.SUPPORT)} replace />;
      }
      if (hasPermission(ADMIN_PERMISSIONS.DASHBOARD.VIEW)) {
        return <Navigate to={adminPath(ADMIN_PATHS.DASHBOARD)} replace />;
      }
      if (hasPermission(ADMIN_PERMISSIONS.SETTINGS.VIEW)) {
        return <Navigate to={adminPath(ADMIN_PATHS.SETTINGS)} replace />;
      }
      if (hasPermission(ADMIN_PERMISSIONS.USERS.VIEW)) {
        return <Navigate to={adminPath(ADMIN_PATHS.USERS)} replace />;
      }
      return <Navigate to={adminPath(ADMIN_PATHS.LOGIN)} replace />;
    }
  }

  return children;
};

export default AdminPermissionRoute;
